import { render } from "./ListInBox.vue?vue&type=template&id=fee2cc98"
import script from "./ListInBox.vue?vue&type=script&lang=js"
export * from "./ListInBox.vue?vue&type=script&lang=js"

import "./ListInBox.vue?vue&type=style&index=0&id=fee2cc98&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__